<template>
  <div class="card-workgroup">
    <div class="card-workgroup__inner">
      <router-link :to="content.route" @click.native.stop="handleClick">
        <span>{{ content.text }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardWorkgroup',
  components: {

  },
  props: {
    content: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">
.card-workgroup{
  margin-bottom: 0;
  &:last-child{
    margin-bottom: 2rem;
  }
  &__title{
    margin-bottom: layout("spacing");
    padding-bottom: .9rem;
    border-bottom: 1px solid tint(black, 80%);
    font-size: 2.4rem;
  }
  a{
    @include text-color(colors("workgroups"), colors("primary"));
    @include icon(icons("chevron-right"));
    @include hover{
      border-color: transparent;
      color: rgba(colors(workgroups), 1);
    }
    color: rgba(colors(workgroups), .6);
    font-size: 1.3rem;
    width: 100%;
    font-weight: font-weights("medium");
    line-height: 1;

    &::before{
      font-size: 1.2rem;
      margin-right: layout("spacing")/4;
    }
  }
}
</style>
